import type { FC } from 'react';
import React from 'react';

import emptyImage from '@wwe-portal/ui/assets/images/common/no-search-results.svg';

interface EmptySearchResultProps {
  children: React.ReactNode;
}
export const EmptySearchResult: FC<EmptySearchResultProps> = ({ children }) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <div>
        <img alt="No search result" src={emptyImage} />
      </div>
      <span className="text-text500 text-xs">{children}</span>
    </div>
  );
};
